// Rating 1-5 con estrellas. Modo lectura o interactivo según `onChange`.

import { Icon } from '@/components/atoms/Icon';
import styles from './StarRating.module.scss';

interface StarRatingProps {
  value: number | null;
  onChange?: (value: number) => void;
  size?: number;
  label?: string;
}

export function StarRating({ value, onChange, size = 20, label }: StarRatingProps) {
  const readOnly = !onChange;
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className={styles.root} role="group" aria-label={label}>
      {stars.map((n) => {
        const filled = value !== null && n <= value;
        return (
          <button
            key={n}
            type="button"
            className={`${styles.star} ${filled ? styles.filled : ''} ${readOnly ? styles.readonly : ''}`}
            onClick={() => onChange?.(n)}
            disabled={readOnly}
            aria-label={`${n} de 5`}
            aria-pressed={filled}
          >
            <Icon name="star" size={size} fill={filled ? 'currentColor' : 'none'} />
          </button>
        );
      })}
    </div>
  );
}
